import { mount } from 'mount-vue-component';
import mitt from 'mitt';
import DDialog from './DDialog.vue';
import { registerComponents, vueUse, registerComponentProgrammatic } from '../../../utils/plugins';
import { removeElement } from '../../../utils/helpers';

const components = {
  DDialog,
};

function open(propsData, app) {
  const emitter = mitt();
  propsData.emitter = emitter;
  const dialog = mount(DDialog, {
    props: propsData,
    app,
  });

  emitter.on('destroy', () => {
    emitter.all.clear();
    removeElement(dialog.el);
    dialog.destroy();
  });
  return dialog;
}

const DialogProgrammatic = (app) => {
  function alert(params) {
    let message;
    if (typeof params === 'string') message = params;
    const defaultParam = {
      canCancel: false,
      message,
    };
    const propsData = Object.assign(defaultParam, params);
    return open(propsData, app);
  }
  function confirm(params) {
    const defaultParam = {};
    const propsData = Object.assign(defaultParam, params);
    return open(propsData, app);
  }
  function prompt(params) {
    const defaultParam = {
      hasInput: true,
      confirmText: 'Done',
    };
    const propsData = Object.assign(defaultParam, params);
    return open(propsData, app);
  }
  return { alert, confirm, prompt };
};

const Registered = {
  install(Vue) {
    registerComponents(Vue, components);
    registerComponentProgrammatic(Vue, '$dialog', DialogProgrammatic(Vue));
  },
};

vueUse(Registered);

export default Registered;

export {
  DialogProgrammatic as DDialog,
};